
import * as angular from "angular";
import { BroadcastEvent } from "@enums/BroadcastEvent";
import { FilterBarService } from "@services/resourceFilterBar.service";
import "./resourceFilterBarModal.scss";

export interface IResourceFilterBarEvent {
    event: MouseEvent;

    modalList?: {
        element: HTMLElement;
        controller: IResourceFilterBarModalController;
        distanceToCommonParent: number;
    }[];
}

export interface IResourceFilterBarModalController {
    show: boolean;
}

class ComponentController implements angular.IComponentController, IResourceFilterBarModalController {

    show: boolean;

    static $inject = ["$scope", "$element", "filterBarService"];

    constructor(
        private readonly $scope: angular.IScope,
        private readonly $element: JQuery,
        private readonly filterBarService: FilterBarService
    ) {
    }

    $onInit() {
        this.$scope.$on(BroadcastEvent.onShowResourceFilterBar, (event, filterBarEvent: IResourceFilterBarEvent) => {

            const distance = this.commonAncestorDistance(this.$element[0], filterBarEvent.event?.target as any);

            filterBarEvent.modalList = filterBarEvent.modalList || [];

            var iAmClosest = filterBarEvent.modalList.length == 0;

            filterBarEvent.modalList.forEach(modal => {
                iAmClosest = iAmClosest || distance < modal.distanceToCommonParent;
            });

            if (iAmClosest) {
                filterBarEvent.modalList.forEach(modal => {
                    modal.controller.show = false;
                });
            }

            filterBarEvent.modalList.push({
                controller: this,
                distanceToCommonParent: distance,
                element: this.$element[0]
            });

            this.show = iAmClosest;
        });

        this.$scope.$on(BroadcastEvent.onHideResourceFilterBar, (event) => {
            this.show = false;
        });
    }
    
    closeResourceFilterBar() {
        this.show = false;
        this.filterBarService.closeFilterBar();
    }

    // ---

    private parents(node: Node): Node[] {
        var nodes = [node]

        for (; node; node = node.parentNode) {
            nodes.unshift(node)
        }

        return nodes
    }

    private commonAncestorDistance(node1: Node, node2: Node): number {
        var parents1 = this.parents(node1);
        var parents2 = this.parents(node2);

        //console.log(parents1);
        //console.log(parents2);

        if (parents1[0] != parents2[0]) {
            throw "No common ancestor!"
        }

        for (var i = 0; i < parents1.length; i++) {
            if (parents1[i] != parents2[i]) {
                //console.log(parents1.length, parents2.length, i);
                return Math.min(parents1.length, parents2.length) - i + 1;
            }
        }
    }
}

export class ResourceFilterBarModalComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
        };

        this.controller = ComponentController;
        this.template = `<div class="modal" ng-click="$ctrl.closeResourceFilterBar()" ng-class="{ 'show': $ctrl.show }"></div>`;
    }
}
